const SCRIPT_TOKEN = '1f250369725168ea72253d897dfd69a18867993e18bf52fce354ade16d6d7213';



export default class WebPushManager {

  /**
   * constructor
   */
  constructor() {
  }



  /**
   * load script
   */
  load() {
    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('charset', 'utf-8');
    script.setAttribute('data-wptoken', SCRIPT_TOKEN);
    script.setAttribute('src', 'https://cdn.webpush.jp/js/webpush.js');
    document.getElementsByTagName('head')[0].appendChild(script);
  }
}


// WEBPACK FOOTER //
// ./src/js/manager/WebPushManager.js